var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTak4Lengeh1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 30",
    style: {
      enableBackground: "new 0 0 60 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.9,15.4h-2.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.2c0.3,0,0.5,0.2,0.5,0.5S38.2,15.4,37.9,15.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.6,11.4 37.6,18.4 40.3,14.9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3,15.2H5.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h5.1c0.3,0,0.5,0.2,0.5,0.5S10.6,15.2,10.3,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8,18.5c-0.3,0-0.5-0.2-0.5-0.5v-6.7c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v6.7C8.3,18.3,8.1,18.5,7.8,18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,30H0V0h60V30z M1,29h58V1H1V29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7,25.3h-9.2V4.4h9.2V25.3z M34.4,24.4h7.3v-19h-7.3V24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9,15.4h-2.2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.2c0.3,0,0.5,0.2,0.5,0.5S25.2,15.4,24.9,15.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.1,18.4 23.1,11.4 20.4,14.9  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2,25.3H18V4.4h9.2V25.3z M19,24.4h7.3v-19H19V24.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v28.7C30.9,29.8,30.6,30,30.4,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v28.7C15.7,29.8,15.5,30,15.2,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2,30c-0.3,0-0.5-0.2-0.5-0.5V0.8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v28.7C45.7,29.8,45.5,30,45.2,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7,15.2h-5.1c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h5.1c0.3,0,0.5,0.2,0.5,0.5S54.9,15.2,54.7,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2,18.5c-0.3,0-0.5-0.2-0.5-0.5v-6.7c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v6.7C52.6,18.3,52.4,18.5,52.2,18.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTak4Lengeh1);
export default __webpack_public_path__ + "static/media/tak_4_lengeh_1.4107e21f14acc1df83b7f2141a617f5a.svg";
export { ForwardRef as ReactComponent };